import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Colors } from "../theme";

export const InfoCompanyDivisionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  margin: "2%",
  width: "92%",
  justifyContent: "center",
  alignItems: "center",
  padding: "2px 8px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    width: "100%",
  },
}));

export const InfoCompanyDivisionContent = styled(Box)(({ theme }) => ({
  width: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  border: `2px solid ${Colors.secondary}`,
  margin: "2%",
  borderRadius: '5%',
  boxShadow: '5px 5px 1px 5px',
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const DivisionImage = styled("img")(({ src, theme }) => ({
  src: `url(${src})`,
  width: "50%",
  margin: "2%",
  [theme.breakpoints.down("md")]: {
    margin: "2%",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "2%",

  },
}));

export const DivisionDescription = styled(Typography)(() => ({
  padding: "4px",
  margin: "2%",
  flexGrow: 1,
  fontSize: "1.2em",
  color: Colors.secondary,
}));


